<template>
  <div class="">
    <div v-if="question.type == 'surveySelect'">
      <div v-for="(option, key) in question.options" :key="key" type="is-primary">
        <b-checkbox
          v-model="answers[key]"
          :disabled="
            (answers.filter((y) => y == true).length >= question.selectable && answers[key] == false) || !canVote
          "
        >
          {{ option.text }}
        </b-checkbox>
      </div>
      <span v-if="question.selectable">({{ $t("selectable") + ": " + question.selectable }})</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurveyQuestions",
  props: {
    question: {
      type: Object,
      default() {
        return {};
      },
    },
    canVote: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      answers: [],
      isLoading: false,
      isDisabled: false,
      questionProgress: null,
      interval: null,
    };
  },
  watch: {
    question: {
      immediate: true,
      handler() {
        if (this.question) {
          if (this.question.type == "surveySelect") {
            this.answers = [];
            for (let option of Object(this.question.options).keys()) {
              this.answers[option] = false;
            }
          }
        }
      },
    },
    answers: {
      deep: true,
      handler() {
        if (this.question.type == "surveySelect") {
          if (this.answers.filter((y) => y == true).length > 0) {
            this.isDisabled = false;
          } else {
            this.isDisabled = true;
          }
        }
        this.$emit("answers", this.answers);
      },
    },
  },
  methods: {},
};
</script>

<style></style>
